var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form" } }, [
    _c("input", {
      directives: [
        { name: "model", rawName: "v-model", value: _vm.url, expression: "url" }
      ],
      attrs: { placeholder: "Enter URL for cut", title: _vm.title },
      domProps: { value: _vm.url },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.url = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("button", { attrs: { id: "#app-form-reset" } }),
    _vm._v(" "),
    _c("button", { attrs: { id: "app-form-copy" } }),
    _vm._v(" "),
    _c("button", { attrs: { id: "app-form-cut" } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }